import { runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ChecklistSectionInDto } from 'shared/dtos/in/template';
import { checklistSectionContract } from './checklistSectionContract';
import type {
  ChecklistSectionCreateModel,
  ChecklistSectionDeleteModel,
  ChecklistSectionDocumentDeleteModel,
  ChecklistSectionEditModel,
  ChecklistSectionReorderModel,
} from './types/model';

/**
 * Checklist sections of a template, changed through the service worker. Each
 * change resolves once the server accepted it and rejects with its error
 * (`ChannelRequestError.messageId`); the template is synced afterwards.
 */
export const checklistSectionClient = {
  /** Resolves with the created section. */
  create(section: ChecklistSectionCreateModel): Promise<ChecklistSectionInDto> {
    return runQueuedMutation(
      checklistSectionContract,
      'create',
      (uniqueId) => ({ section, uniqueId }),
      DomainMessagesTypes.checklistSectionCreated
    );
  },

  async edit(section: ChecklistSectionEditModel): Promise<void> {
    await runQueuedMutation(
      checklistSectionContract,
      'edit',
      (uniqueId) => ({ section, uniqueId }),
      DomainMessagesTypes.checklistSectionUpdated
    );
  },

  async remove(section: ChecklistSectionDeleteModel): Promise<void> {
    await runQueuedMutation(
      checklistSectionContract,
      'remove',
      (uniqueId) => ({ section, uniqueId }),
      DomainMessagesTypes.checklistSectionDeleted
    );
  },

  async reorder(section: ChecklistSectionReorderModel): Promise<void> {
    await runQueuedMutation(
      checklistSectionContract,
      'reorder',
      (uniqueId) => ({ section, uniqueId }),
      DomainMessagesTypes.checklistSectionReordered
    );
  },

  async removeDocument(model: ChecklistSectionDocumentDeleteModel): Promise<void> {
    await runQueuedMutation(
      checklistSectionContract,
      'removeDocument',
      (uniqueId) => ({ model, uniqueId }),
      DomainMessagesTypes.checklistSectionDocumentDeleted
    );
  },
};
